import { COMPANY_INITIALS, COMPANY_SHORT } from '../constants';

const navItems = [
  { label: 'Record', href: '#record' },
  { label: 'Structure', href: '#structure' },
  { label: 'Address', href: '#address' },
];

function Header() {
  return (
    <header className="sticky top-0 z-30 border-b border-line bg-paper/88 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
        <a
          href="#top"
          className="flex min-w-0 items-center gap-3"
          aria-label={`${COMPANY_SHORT} home`}
        >
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-lg bg-ink text-sm font-black text-cyan shadow-ring">
            {COMPANY_INITIALS}
          </span>
          <span className="truncate text-xl font-black tracking-tight text-ink sm:text-2xl">
            {COMPANY_SHORT}
          </span>
        </a>
        <nav
          className="hidden items-center gap-2 md:flex"
          aria-label="Primary"
        >
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-pill px-4 py-2 text-sm font-semibold text-muted transition hover:bg-steel hover:text-ink"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <a
          href="#address"
          className="rounded-pill bg-ink px-5 py-2.5 text-sm font-semibold text-paper transition hover:bg-teal"
        >
          View address
        </a>
      </div>
    </header>
  );
}

export default Header;
